export default function timetableReducer(timetable, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "name":
      return {
        ...timetable,
        [action.type]: action.value,
        exten: `tt-${action.value
          .replace(/\s+/g, " ")
          .replace(/^\s|\s$/g, "")
          .split(" ")
          .join("-")}`,
      };

    case "updateHour": {
      const _timetable = Object.assign({}, timetable);
      const days = action.position === "week" ? ["mon", "tue", "wed", "thu", "fri"] : ["sat", "sun"];
      const hourPosition = action.hour * 4;

      for (let dayInt = 0; dayInt < days.length; dayInt++) {
        _timetable.conditions[days[dayInt]].fill(Number(action.destination?.id || 0), hourPosition, hourPosition + 4);
      }

      return _timetable;
    }
    case "updateDay": {
      const _timetable = Object.assign({}, timetable);
      _timetable.conditions[action.day].fill(Number(action.destination?.id || 0), 0);
      return _timetable;
    }
    case "updateSelection": {
      const _timetable = Object.assign({}, timetable);

      action.selection.map(
        (item) => (_timetable.conditions[item.props.day][item.props.place] = Number(action.destination?.id || 0)),
      );

      return _timetable;
    }

    case "addRule":
      return { ...timetable, rules: [...timetable.rules, action.rule] };
    case "updateRule":
      return {
        ...timetable,
        rules: timetable.rules.map((_rule) => {
          if (_rule.id === action.rule.id) {
            _rule = action.rule;
          }
          return _rule;
        }),
      };
    case "deleteRule": {
      const conditions = Object.assign({}, timetable.conditions);

      Object.keys(conditions).map((key) => {
        conditions[key] = conditions[key].map((condition) => {
          if (condition === action.rule.id) return 0;

          return condition;
        });
      });

      return {
        ...timetable,
        rules: timetable.rules.filter((_rule) => _rule.id !== action.rule.id),
        conditions,
      };
    }

    case "addHolidaySet":
      return { ...timetable, holidaySets: [...timetable.holidaySets, action.holidaySet] };
    case "removeHolidaySet":
      return {
        ...timetable,
        holidaySets: timetable.holidaySets.filter((_holidaySet) => _holidaySet.id !== action.holidaySet.id),
      };

    default:
      return { ...timetable, [action.type]: action.value };
  }
}
